const realisations = [
  {
    name: "DATA 4 – DC23",
    client: "SOPREMA GROUPE",
    type: "Travaux d'étanchéité",
    icon: "ri-server-line",
  },
  {
    name: "CAMPUS CACHAN",
    client: "CESAM TREUIL",
    type: "Travaux d'étanchéité",
    icon: "ri-school-line",
  },
  {
    name: "CŒUR DE VILLE BOBIGNY",
    client: "COGEDIM",
    type: "Travaux d'étanchéité",
    icon: "ri-building-4-line",
  },
];

export default function ClientsSection() {
  return (
    <section id="clients" className="py-12 md:py-24 bg-[#f5fdf8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Nos réalisations en étanchéité
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            Ils nous ont fait confiance pour leurs projets d&apos;étanchéité et d&apos;imperméabilisation
          </p>
        </div>

        {/* Realisation Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {realisations.map((r) => (
            <div key={r.name} className="bg-white rounded-2xl p-6 md:p-8 border border-gray-100 text-center hover:border-[#a8f0c0] hover:bg-[#f5fdf8] transition-all group">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#e6f7ed] text-[#00a340] mx-auto mb-5 group-hover:bg-[#00a340] group-hover:text-white transition-all">
                <i className={`${r.icon} text-2xl`}></i>
              </div>
              <div className="text-[10px] font-semibold uppercase tracking-widest text-[#00a340] mb-2">{r.type}</div>
              <div className="font-extrabold text-gray-900 text-base md:text-lg mb-3 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>{r.name}</div>
              <div className="flex items-center justify-center gap-1.5 text-gray-400 text-xs">
                <i className="ri-user-star-line text-sm"></i>
                <span>{r.client}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
